var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuacSymbolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3576 2.96875C42.9362 2.96875 37.9393 5.35343 33.6654 8.7696C29.3797 12.1952 25.5648 16.853 22.3948 21.9481C16.1057 32.0567 11.875 44.6808 11.875 54.5767C11.875 75.0858 30.6853 89.7034 48.3576 89.7034C65.9539 89.7034 85.3103 75.1537 85.3103 54.5767C85.3103 44.6954 81.1618 32.0707 74.8365 21.9423C71.6493 16.8386 67.7906 12.1731 63.4118 8.74444C59.0346 5.31702 53.9253 2.96875 48.3576 2.96875ZM19.9702 54.5767C19.9702 46.5786 23.5457 35.4226 29.2683 26.2245C32.1043 21.6662 35.3467 17.7891 38.7197 15.0931C42.1045 12.3876 45.3676 11.064 48.3576 11.064C51.5809 11.064 54.9802 12.424 58.421 15.1182C61.8603 17.8112 65.129 21.6806 67.9702 26.2303C73.702 35.4085 77.2151 46.564 77.2151 54.5767C77.2151 69.7877 62.4342 81.6081 48.3576 81.6081C34.357 81.6081 19.9702 69.8555 19.9702 54.5767ZM62.1801 56.8971C62.1801 64.1336 55.2318 69.4658 48.7851 69.4658C42.3384 69.4658 35.5815 64.1336 35.5815 56.8971C35.5815 49.6605 42.3384 37.6631 48.7851 37.6631C55.2318 37.6631 62.1801 49.6605 62.1801 56.8971Z",
    fill: "url(#paint0_linear_1417_13660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1417_13660",
    x1: 49.1987,
    y1: -6.72673,
    x2: -5.15489,
    y2: 40.9077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E429"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuacSymbolLogo);
export default __webpack_public_path__ + "static/media/Guac_Symbol_Logo.ba6dce79d4176433316381767bbfc166.svg";
export { ForwardRef as ReactComponent };